import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { CANVAS_GREY_CLASS, canvasIsGrey } from '../lib/section-tones'

/**
 * Keeps the canvas the same tone as the footer.
 *
 * iOS Safari tints the strip behind its bottom toolbar from the canvas, and the
 * footer's tone alternates per route (see lib/section-tones), so a fixed canvas
 * colour is wrong on half the site, a navy strip under an ashy footer. This
 * reads the same table the footer reads, so the two cannot drift.
 *
 * This only works because the navbar is opaque: Safari samples that for the TOP
 * strip instead of the canvas, which is what leaves the canvas free to follow the
 * footer. If the navbar ever goes translucent again, both ends fall back to the
 * canvas and this turns the top strip ashy, and a unit test guards that.
 *
 * Renders nothing and lives inside the Router, like ScrollToTop, because it needs
 * the active pathname. It writes to <html>, outside React's tree, so an effect is
 * the correct escape hatch rather than a rendered className.
 */
const CanvasTone = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    document.documentElement.classList.toggle(CANVAS_GREY_CLASS, canvasIsGrey(pathname))
  }, [pathname])

  return null
}

export default CanvasTone
